import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DetalleTransaccion } from 'src/app/model/pld/detalletransacciones.model';
import { Bitacora } from 'src/app/model/pld/bitacora.model';
import { BitacoraCargaDatosModel } from 'src/app/model/carga/BitacoraCargaDatos';

@Injectable({
	providedIn: 'root',
})
export class TransaccionesService {
	endpoint = `${environment.apiUrl}PLD/administraciontransacciones`;
	endpointreportes = `${environment.apiUrl}Reportes/pld`;

	//endpoint = 'https://localhost:64265/' + 'administraciontransacciones';
	//endpointreportes = 'http://localhost:5210/pld';

	httpOptions = {};

	constructor(private http: HttpClient) { }

	buscarTransacciones(values: any): Observable<any> {
	    return this.http.post<any>(
      	`${this.endpoint}/buscarTransacciones`,
        values
    	);	
	}

	buscarTransaccionesConteo(values): Observable<any> {
		return this.http.post<any>(
		this.endpoint + '/obtenerTotalTransacciones',
		JSON.stringify(values)
		);
	}

	buscarTransaccionesContratoCapt(values): Observable<any> {
		return this.http.post<any>(
			`${this.endpoint}/buscarTransaccionesContratoCapt`,
			JSON.stringify(values)
		);
	}


	buscarTransaccionesContratoCred(values): Observable<any> {
		return this.http.post<any>(
			`${this.endpoint}/buscarTransaccionesContratoCred`,
			JSON.stringify(values)
		);
	}

	buscarReporteTransacciones(values): Observable<any> {
		let result = this.http.post<any>(
			`${this.endpoint}/reportetransaccion`,
			JSON.stringify(values)
		);
		return result;
	}

	buscarReporte(values): Observable<any> {
		let result = this.http.post<any>(
			`${this.endpointreportes}/transacciones`,
			JSON.stringify(values)
		);
		return result;
	}

	asignarTransaccion(values: DetalleTransaccion): Observable<any> {
		return this.http.post<any>(
			`${this.endpoint}/actualizarBanderaTSeleccionado`,
			JSON.stringify(values)
		);
	}

	buscarBitacoraMonitoreo(values: Bitacora): Observable<any> {
		return this.http.post<any>(
			`${this.endpoint}/bitacoraMonitoreo`,
			JSON.stringify(values)
		);
	}

	buscarOperaciones(values: Bitacora,casoId: number): Observable<any> {
		return this.http.post<any>(
			`${this.endpoint}/bitacoraOperaciones?CasoId=${casoId}`,
			JSON.stringify(values)
		);
	}
	

	buscarReporteMonitoreo(values): Observable<any> {
		let result = this.http.post<any>(
			`${this.endpoint}/reporteMonitoreo`,
			JSON.stringify(values)
		);
		return result;
	}
}
